var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3158 15.5455H5.05263C4.58947 15.5455 4.19298 15.3763 3.86316 15.0381C3.53333 14.6998 3.36842 14.2932 3.36842 13.8182V1.72727C3.36842 1.25227 3.53333 0.845644 3.86316 0.507386C4.19298 0.169129 4.58947 0 5.05263 0H10.9474L16 5.18182V13.8182C16 14.2932 15.8351 14.6998 15.5053 15.0381C15.1754 15.3763 14.7789 15.5455 14.3158 15.5455ZM10.1053 6.04545V1.72727H5.05263V13.8182H14.3158V6.04545H10.1053ZM1.68421 19C1.22105 19 0.824561 18.8309 0.494737 18.4926C0.164912 18.1544 0 17.7477 0 17.2727V5.18182H1.68421V17.2727H10.9474V19H1.68421Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.88a3c8437c0cc7a6cb1388bc84e77e12.svg";
export { ForwardRef as ReactComponent };